// extracted by mini-css-extract-plugin
export default {"root":"DeleteAvatarModal_root__D-WdM","container":"DeleteAvatarModal_container__esJfL"};